// ONE DOCUMENT'S PAYMENT STATUS, IN WORDS — moved here from the pro forma
// window (ProFormaModal.tsx) so every place that prints ONE document's status
// reads the same words.
//
// 179 C.6 — the raw enum rendered "unpaid" / "paid" / "cancelled" in English in
// a trilingual app; partially_paid keeps its own key. 208 §21 — ONE document's
// status, in the singular: the STATUS words (invoice.status.unpaid « Impayé »,
// invoice.status.paid « Payé », as the cancelled chip already read
// invoice.status.cancelled). The list filter's words (invoice.pf.*,
// « Impayées » / « Payées ») name a set of documents and stay the filter's.
import type { TFn } from "./taxonomyTypes";

/** The words for one document's `paymentStatus`; a value outside the enum is printed as it came. */
export function invoiceStatusWord(status: string | null | undefined, t: TFn): string {
  if (status === "partially_paid") return t("proforma.status.partially_paid", { fallback: "Partially Paid" });
  if (status === "unpaid") return t("invoice.status.unpaid", { fallback: "Unpaid" });
  if (status === "paid") return t("invoice.status.paid", { fallback: "Paid" });
  if (status === "cancelled") return t("invoice.status.cancelled", { fallback: "Cancelled" });
  // 209 §16 [JUDGEMENT] — the enum's two other values, which no path reaches since
  // 179 C but which older rows still hold (staging's fixture: two drafts). A
  // report row is ONE document, so it prints a word, never the code.
  if (status === "draft") return t("invoice.status.draft", { fallback: "Draft" });
  if (status === "ready") return t("invoice.status.ready", { fallback: "Ready" });
  return status ?? "";
}
